import React, { ReactElement, useEffect, useState } from 'react';
import TextField from '../../../components/inputs/text-field';
import Modal from '../../../components/modal/modal';
import useLocale from '../../../hooks/use-locale';

type Props = {
    open: boolean;
    input: string;
    onClose(): void;
    onSubmit(name: string): void;
};

export default function RenameCampaignItemForm(props: Props): ReactElement {
    const { open, input, onClose, onSubmit } = props;

    const [name, setName] = useState(input);

    const { getText } = useLocale();

    useEffect(() => {
        setName(input);
    }, [open]);

    return (
        <Modal
            onClose={() => {
                onClose();
                setName('');
            }}
            title={getText('widgets.campaigns.rename.title')}
            open={open}
            actions={[
                {
                    id: 'rename',
                    label: getText('widgets.campaigns.rename.action'),
                    variant: 'text',
                },
            ]}
            onSubmit={() => {
                onSubmit(name);
                setName('');
            }}
            maxWidth='600px'
            maxHeight='760px'
        >
            <div className='flex w-full py-5'>
                <TextField
                    label={getText('widgets.campaigns.rename.label')}
                    value={name}
                    className='my-2 w-full'
                    onChange={(e) => setName(e.currentTarget.value)}
                />
            </div>
        </Modal>
    );
}
